import { type FC } from 'react';
import { Loader } from '../../../../feedback/loader';
import { Shine } from '../../../../feedback/shine';
import { LoadingType } from '../../enums';

type Props = HasClassName<{
  type: LoadingType;
}>;

export const Entry: FC<Props> = ({ type, className }) => {
  if (type === LoadingType.SPINNER) {
    return <Loader className={className} size="s" />;
  }

  return <Shine className={className} />;
};
